<template>
  <v-card class="rounded-card card-shadow" color="primary">
    <v-card-title class="white--text font-weight-bold pl-5">
      Acessos a ofertas por dia
    </v-card-title>
    <figure style="width: 100%;">
      <v-chart :options="chart"
               ref="acessosDiaChart"
               theme="primarydark"
               autoresize/>
    </figure>
  </v-card>
</template>

<script>
import moment from 'moment';
import { toEchartData } from '@/utils/chart-utils';
import chartMixin from '@/mixins/chart-mixin';
import {
  formatToCode,
  VIEW_FORMAT,
} from '@/utils/moment-date-utils';
import DashboardAcessoService from './dashboard-acessos';


export default {
  mixins: [chartMixin],
  props: {
    stateDate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      acessosDias: null,
      chart: null,
    };
  },
  computed: {
    query() {
      return `data >= ${this.stateDate.initialDate} and data <= ${this.stateDate.finalDate}`;
    },
  },
  methods: {
    showLoading() {
      this.$refs.acessosDiaChart.showLoading(this.loadingConfig);
    },
    hideLoading() {
      this.$refs.acessosDiaChart.hideLoading();
    },
    buildChart(data) {
      return {
        width: '80%',
        tooltip: {
          trigger: 'axis',
        },

        dataset: {
          source: [
            ['Orders'],
            ...toEchartData(data, 'description', 'value'),
          ],
        },
        xAxis: {
          type: 'category',
          interval: 1,
          maxInterval: 1,
        },
        yAxis: {
          splitNumber: 8,
        },
        grid: {
          top: '15px',
          left: '10%',
        },
        series: [
          {
            type: 'line',
            // smooth: true,
            lineStyle: {
              width: 2,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
    },
    buildDataPoints(data) {
      const start = moment(this.stateDate.initialDate);
      const endDate = moment(this.stateDate.finalDate);

      const dataPoints = [];

      while (start.isSameOrBefore(endDate)) {
        dataPoints.push({
          description: start.format(VIEW_FORMAT),
          value: data[formatToCode(start)] || 0,
        });
        start.add(1, 'day');
      }
      this.chart = this.buildChart(dataPoints);
    },
    getComprasPorDia() {
      this.showLoading();
      DashboardAcessoService.getAcessosPorDia({
        query: this.query,
      })
        .then(({ data }) => {
          this.acessosDias = data;
          this.buildDataPoints(this.acessosDias);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
  watch: {
    stateDate(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getComprasPorDia();
    },
  },
  mounted() {
    this.getComprasPorDia();
  },
};
</script>

<style scoped>
figure .echarts {
  width: 100%;
  height: 300px;
  /*max-width: 400px;*/
}
</style>
